/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_S2Inputs */

const en_mk_tut_apa_s2 = /** @type {(inputs: Mk_Tut_Apa_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**A division** is a grouping like Marketing or Finance. Each one gets its own chat channel and one agent with the matching skills.`)
};

const id_mk_tut_apa_s2 = /** @type {(inputs: Mk_Tut_Apa_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Divisi** adalah pengelompokan seperti Marketing atau Finance. Tiap divisi punya channel obrolan sendiri dan satu agen dengan keahlian yang cocok.`)
};

/**
* | output |
* | --- |
* | "**A division** is a grouping like Marketing or Finance. Each one gets its own chat channel and one agent with the matching skills." |
*
* @param {Mk_Tut_Apa_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_s2 = /** @type {((inputs?: Mk_Tut_Apa_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_s2(inputs)
	return en_mk_tut_apa_s2(inputs)
});